import React from "react"
import Label from "@kit/design/label"
import Input from "@kit/design/input"
import { ColorInput } from "@kit/design/color-picker"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { Padding } from "../../components/padding"
import { Margin } from "app/regions/blocks/section/utils/margin"
import { ColumnRatio } from "../../components/column-ratio"
import { BlocksImageUploader } from "app/regions/blocks/shared/blocks-image-uploader"
import { Expander } from "app/regions/blocks/shared/expander"
import { BackgroundColor } from "../../components/background-color"
import { BorderSettings } from "../../components/border-settings"
import { FontSettings } from "../../../header/utils/font-settings"
import { ImageBorderRadius } from "../../components/image-border-radius"
import { useSavedColors } from "hooks/use-saved-colors"

export function SponsorCTALeftSmallImageSettings({ block_id }) {
  const { properties, update } = useBlocks(block_id)
  const savedColors = useSavedColors()

  return (
    <>
      <div className="mb-4">
        <BlocksImageUploader
          className="h-40"
          label="Image"
          name="image"
          image={properties.image}
          alt={properties.alt}
          update={file =>
            update({
              image: file.image || properties.image,
              alt: file.alt
            })
          }
          remove={() => update({ image: "", alt: "" })}
        />
      </div>

      <div className="mb-4">
        <ImageBorderRadius properties={properties} update={update} />
      </div>

      <div className="mb-4">
        <Label htmlFor="imageUrl">Image URL</Label>
        <Input
          className="text-gray-700 mb-1 w-full"
          placeholder="https://example.com"
          name="imageUrl"
          onChange={e => update({ imageUrl: e.target.value })}
          value={properties.imageUrl || ""}
        />
      </div>

      <div className="mb-4">
        <ColumnRatio properties={properties} update={update} />
      </div>

      <Expander label="Colors">
        <BackgroundColor properties={properties} update={update} />

        <div>
          <Label htmlFor="sponsorLabelColor">Sponsor label</Label>
          <ColorInput
            id="sponsorLabelColor"
            name="sponsorLabelColor"
            onChange={color => update({ sponsorLabelColor: color.hex })}
            value={properties.sponsorLabelColor}
            savedColors={savedColors}
          />
        </div>

        <div>
          <Label htmlFor="headingColor">Heading</Label>
          <ColorInput
            id="headingColor"
            name="headingColor"
            onChange={color => update({ headingColor: color.hex })}
            value={properties.headingColor}
            savedColors={savedColors}
          />
        </div>

        <div>
          <Label htmlFor="textColor">Text</Label>
          <ColorInput
            id="textColor"
            name="textColor"
            onChange={color => update({ textColor: color.hex })}
            value={properties.textColor}
            savedColors={savedColors}
          />
        </div>
      </Expander>

      <Expander label="Spacing">
        <div className="mb-4">
          <Padding properties={properties} update={update} />
        </div>

        <div className="mb-4">
          <Margin properties={properties} update={update} />
        </div>
      </Expander>

      <Expander label="Fonts">
        <FontSettings
          label="Sponsor label"
          fontFamilySetting="sponsorLabelFontFamily"
          fontWeightSetting="sponsorLabelFontWeight"
          properties={properties}
          update={update}
        />
        <FontSettings
          label="Heading font"
          fontFamilySetting="headingFontFamily"
          fontWeightSetting="headingFontWeight"
          properties={properties}
          update={update}
        />
        <FontSettings
          label="Text font"
          fontFamilySetting="textFontFamily"
          fontWeightSetting="textFontWeight"
          properties={properties}
          update={update}
        />
      </Expander>

      <BorderSettings properties={properties} update={update} />
    </>
  )
}
